import React from 'react';
import Search from '../components/search';
import { Helmet } from 'react-helmet';

function SearchView() {
  return (
    <>
      <Helmet>
        <meta charSet='utf-8' />
        <meta
          name='description'
          content='Fishing lakes near me? Use swimbooker’s directory of over 1000+ carp and course lakes to find the best places to fish near you.'
        />
        <title>
          Find The Best Fishing Lakes Near You | swimbooker Fishery Search
        </title>
      </Helmet>
      <Search />
    </>
  );
}

export default SearchView;
